<div class="header">
  <h3 class="title">
    {{
      (followType === 'FOLLOWER'
        ? 'dashboard.popup-followers.followers'
        : 'dashboard.popup-followers.followings'
      ) | translate
    }}
  </h3>
</div>
<div class="content">
  <div
    class="list-user"
    *ngVar="usersLoaded$ | async as isLoaded"
    infiniteScroll
    [fromRoot]="true"
    [infiniteScrollDistance]="1.1"
    [infiniteScrollThrottle]="70"
    [infiniteScrollDisabled]="(usersLoading$ | async) || isLoaded"
    [infiniteScrollContainer]="scrollContainerSelector"
    (scrolled)="getFollows(isLoaded)">
    @for (user of users$ | async; track user) {
      <div class="list-user__item">
        <app-avatar
          [image]="user.avatar_url"
          [routerLink]="['/dashboard/profile', user.id]"
          class="user-avatar"></app-avatar>
        <div class="user-information">
          <div class="username" [routerLink]="['/dashboard/profile', user.id]">
            {{ user.username }}
          </div>
          @if (user.description && screen.mode !== displayModeEnum.mobile) {
            <div
              class="user-description"
              [innerHTML]="user.description | stripTags"></div>
          }
        </div>
      </div>
    }
  </div>
  @if (usersLoading$ | async) {
    @for (i of [].constructor(6); track $index) {
      <div class="skeleton-container">
        <kin-skeleton
          class="avatar-skeleton"
          [borderRadius]="50"
          [height]="70"
          [width]="70"
          unit="px"></kin-skeleton>
        <kin-skeleton
          [borderRadius]="5"
          [height]="1"
          [width]="5"
          unit="em"></kin-skeleton>
      </div>
    }
  } @else if (totalItems === 0) {
    <div translate>dashboard.profile.no-items.no-followers</div>
  }
</div>
